// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Award from "../domain/types/Award.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as GAEvents from "../../../library/ga/GAEvents.bs.js";
import * as RewardMilestone from "../domain/types/RewardMilestone.bs.js";
import * as RnrAssetManager from "../assets/RnrAssetManager.bs.js";
import * as RnrModalsHelper from "./helpers/RnrModalsHelper.bs.js";
import * as RnrRouteManager from "../routing/RnrRouteManager.bs.js";
import * as RnrParamsContext from "../utils/version/RnrParamsContext.bs.js";
import * as RescriptReactRouter from "../../../../node_modules/@rescript/react/src/RescriptReactRouter.bs.js";

var giftIcon = RnrAssetManager.getImage("gift_icon.svg");

function AwardCardViewComponent(Props) {
  var milestoneDetails = Props.milestoneDetails;
  var onAwardClick = Props.onAwardClick;
  var title = Props.title;
  var detail = Props.detail;
  var awardIconOpt = Props.awardIcon;
  var awardIcon = awardIconOpt !== undefined ? awardIconOpt : giftIcon;
  var rnrParams = RnrParamsContext.getRnrParams(undefined);
  return React.createElement("div", {
              className: "award-card-component__container",
              onClick: (function (_event) {
                  RescriptReactRouter.push(RnrRouteManager.RouteManager.getURLFromRoute(rnrParams.auth_token, rnrParams.lang, rnrParams.version, {
                            TAG: /* RnrHome */0,
                            _0: rnrParams.uuid,
                            _1: undefined,
                            _2: undefined,
                            _3: RewardMilestone.toUrlString(milestoneDetails.currentMilestone)
                          }));
                  GAEvents.publishPageView("rnr/home/award_modal/" + Award.toString(RnrModalsHelper.getAward(milestoneDetails, milestoneDetails.currentMilestone, true)), "RnR Home Award Modal", undefined);
                  return Curry._1(onAwardClick, undefined);
                })
            }, React.createElement("div", {
                  className: "award-card-component__icon-box"
                }, React.createElement("img", {
                      className: "award-card-component__icon",
                      src: awardIcon
                    })), React.createElement("div", {
                  className: "award-card-component__text"
                }, React.createElement("div", {
                      className: "award-card-component__title"
                    }, title), React.createElement("div", {
                      className: "award-card-component__detail"
                    }, detail)), React.createElement("div", {
                  className: "award-card-component__info-icon"
                }, "\u24D8"));
}

var make = AwardCardViewComponent;

export {
  giftIcon ,
  make ,
  
}
/* giftIcon Not a pure module */
